/** Besty mark, same SVG as bestyDashboard exec-hub/besty-mark.tsx. */
export const BestyMark = ({ size = 20, className }: { size?: number; className?: string }) => {
  return (
    <svg
      viewBox="0 0 847.508964 784.296240"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <g transform="translate(-112.911676,873.474562) scale(0.100000,-0.100000)">
        <path
          d={
            'M6495 8730 c-168 -13 -312 -45 -375 -84 -30 -18 -77 -41 -105 -50 -27 -9 -65 -29 -85 -45 -19 -15 ' +
            '-50 -36 -68 -45 -41 -21 -106 -79 -311 -279 -149 -145 -163 -161 -157 -187 4 -20 111 -136 368 -397 ' +
            '200 -202 385 -388 413 -413 27 -25 116 -112 197 -195 81 -82 164 -167 185 -188 21 -21 191 -189 379 ' +
            '-375 224 -222 350 -354 369 -387 16 -27 42 -66 57 -86 16 -20 40 -70 53 -110 13 -41 34 -101 46 ' +
            '-134 32 -85 32 -293 2 -375 -12 -30 -34 -92 -50 -136 -16 -45 -43 -99 -60 -120 -17 -22 -40 -57 -51 ' +
            '-79 -11 -22 -49 -68 -84 -102 -35 -34 -246 -243 -469 -465 -224 -221 -434 -430 -468 -463 -34 -33 ' +
            '-119 -118 -189 -190 -70 -71 -159 -159 -197 -195 -37 -36 -95 -93 -127 -127 -103 -111 -151 -45 525 ' +
            '-720 l582 -583 43 0 43 0 743 743 c409 408 845 842 967 964 440 437 609 617 633 675 8 18 28 50 45 ' +
            '71 16 22 39 63 51 93 11 30 35 76 53 102 19 28 39 74 46 108 7 32 27 90 43 128 49 114 61 202 62 ' +
            '466 1 276 -11 386 -55 479 -16 35 -38 100 -49 145 -12 48 -32 97 -50 122 -16 22 -38 64 -48 92 -11 ' +
            '29 -34 68 -51 88 -17 19 -43 57 -57 85 -36 73 -96 143 -268 316 -83 84 -182 184 -221 223 -38 38 ' +
            '-126 126 -195 194 -69 69 -160 160 -203 203 -698 702 -944 937 -1055 1007 -21 13 -44 31 -51 40 -17 ' +
            '20 -70 48 -125 66 -21 7 -59 25 -85 41 -33 20 -82 35 -176 53 -151 29 -280 37 -420 26z'
          }
        />
        <path
          d={
            'M3567 8399 c-144 -17 -165 -22 -220 -52 -34 -19 -86 -42 -115 -52 -30 -9 -68 -30 -85 -45 -18 -15 ' +
            '-49 -36 -69 -46 -51 -26 -170 -139 -685 -649 -244 -242 -458 -453 -474 -470 -150 -148 -399 -407 ' +
            '-418 -435 -13 -19 -39 -51 -56 -70 -18 -19 -40 -55 -49 -80 -10 -24 -32 -65 -51 -90 -18 -25 -38 ' +
            '-63 -45 -85 -7 -22 -26 -64 -42 -93 -20 -35 -47 -120 -79 -250 l-50 -197 4 -245 c3 -223 5 -251 26 ' +
            '-315 13 -38 32 -112 42 -164 14 -66 29 -109 54 -150 19 -31 41 -77 49 -103 8 -26 29 -69 48 -95 20 ' +
            '-26 43 -70 53 -96 24 -65 145 -199 509 -565 160 -161 302 -304 316 -317 181 -180 2661 -2649 2684 ' +
            '-2674 17 -18 54 -44 81 -58 28 -14 68 -38 90 -53 55 -38 102 -49 230 -56 125 -7 237 6 299 36 125 ' +
            '60 163 93 475 403 174 173 344 343 378 378 33 35 75 76 92 91 56 47 49 60 -134 240 -91 90 -177 174 ' +
            '-191 188 -14 14 -170 171 -347 350 -177 179 -360 361 -407 405 -47 44 -137 134 -200 201 -63 66 ' +
            '-153 156 -200 200 -47 43 -115 111 -151 149 -36 39 -126 129 -200 200 -74 72 -184 182 -246 245 -61 ' +
            '63 -151 153 -200 200 -49 47 -117 115 -153 153 -78 81 -555 553 -590 584 -54 47 -130 143 -146 184 ' +
            '-9 24 -28 59 -41 77 -13 17 -30 47 -37 65 -22 53 -50 236 -49 327 0 102 37 315 61 350 9 14 33 55 ' +
            '52 92 54 102 191 234 330 319 103 63 123 69 276 86 133 15 156 15 289 0 157 -18 181 -26 296 -100 ' +
            '98 -62 144 -105 460 -419 169 -169 299 -290 314 -294 14 -3 37 -3 51 0 16 4 125 107 277 259 303 ' +
            '304 429 417 531 477 107 63 126 78 126 104 0 16 -41 65 -129 157 -71 74 -138 143 -150 154 -12 11 ' +
            '-192 191 -401 400 -209 209 -389 389 -401 400 -11 11 -116 115 -233 230 -322 319 -516 479 -623 515 ' +
            '-32 11 -85 34 -119 51 -52 26 -84 33 -225 49 -200 24 -278 23 -482 -1z'
          }
        />
      </g>
    </svg>
  );
};
